module.exports = __webpack_public_path__ + "static/fonts/Material-Design-Iconic-Font.d2a55d3.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/mdi-font/fonts/Material-Design-Iconic-Font.woff?v=2.2.0
// module id = u8zK
// module chunks = 2